module.exports = __webpack_public_path__ + "ticket.3bb6f8b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/ticket.png
// module id = 1521
// module chunks = 0